<div class="icon-container">
  <button mat-icon-button (click)="onClick()">
    <mat-icon [matTooltip]="adminMode ? 'edit' : 'view all data'" class="material-symbols-outlined">
      {{ adminMode ? 'edit' : 'expand_content' }}
    </mat-icon>
  </button>
</div>
